import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import FeatureSection from '@/pages/home/components/FeatureSection';
import StatsSection from '@/pages/home/components/StatsSection';
import DownloadCTA from '@/pages/home/components/DownloadCTA';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import FAQSection from '@/pages/home/components/FAQSection';
import ArticlePreview from '@/pages/home/components/ArticlePreview';
import Footer from '@/components/feature/Footer';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91网页浏览器',
    url: 'https://www.91browser.com',
    description: '91网页浏览器是一款专为用户打造的极速、安全、稳定网页浏览工具。',
    foundingDate: '2022',
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91网页浏览器',
    url: 'https://www.91browser.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.91browser.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '91网页浏览器 - 极速安全的网页浏览体验',
    description: '91网页浏览器是一款专为用户打造的极速、安全、稳定网页浏览工具。支持多标签、广告拦截、隐私保护等核心功能。',
    url: 'https://www.91browser.com',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />

      <SEOHead
        title="91网页浏览器 - 极速安全的网页浏览体验 | 官方下载"
        description="91网页浏览器是一款专为用户打造的极速、安全、稳定网页浏览工具。支持多标签、广告拦截、隐私保护等核心功能，让您的每一次网页浏览更流畅、更高效。立即下载91网页浏览器，开启全新上网体验。"
        keywords="91网页浏览器,91网页浏览器下载,91网页浏览器官方版,91网页浏览器极速版,91浏览器安全防护,网页浏览器推荐"
        canonicalUrl="https://www.91browser.com"
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <StatsSection />
        <DownloadCTA />
        <TestimonialSection />
        <FAQSection />
        <ArticlePreview />
      </main>
      <Footer />
    </>
  );
}